var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { createContext, useContext, useReducer } from "react";
import { KanbanBoard } from "./board";
var kanbanData = {
    panels: [],
    cards: {},
    cardId: null,
    cardTag: null,
    panelId: null,
    panelTag: null,
    hasUpdate: false,
};
var KanbanContext = createContext([
    kanbanData,
    function () { return null; },
]);
KanbanContext.displayName = "KanbanProvider";
var KanbanDispatch = createContext(function () { return null; });
KanbanDispatch.displayName = "KanbanDispatch";
export var useKanbanContext = function () {
    return useContext(KanbanContext);
};
export var useKanbanDispatch = function () {
    return useContext(KanbanDispatch);
};
var dispatchFn = function (state, action) {
    if (Array.isArray(action)) {
        return action.reduce(function (acc, curr) { return dispatchFnSwitch(acc, curr); }, __assign({}, state));
    }
    else {
        return dispatchFnSwitch(state, action);
    }
};
var dispatchFnSwitch = function (state, action) {
    switch (action.type) {
        case "HANDLE_MOUSE_DOWN_CARD": {
            return __assign(__assign({}, state), { cardId: action.payload });
        }
        case "HANDLE_MOUSE_UP_CARD": {
            console.log({ state: state });
            var newState = __assign({}, state);
            if (state.cardId !== null && state.cardTag !== null && state.panelTag !== null) {
                if (state.cardTag !== state.panelTag) {
                    var cards = __assign({}, state.cards);
                    cards[state.cardId] = __assign(__assign({}, cards[state.cardId]), { tag: state.panelTag });
                    newState = __assign(__assign({}, state), { cards: cards, cardTag: null, cardId: null, panelId: null, panelTag: null });
                }
            }
            else {
                newState = __assign(__assign({}, state), { cardTag: null, cardId: null, panelId: null, panelTag: null });
            }
            console.log(newState);
            return newState;
        }
        case "HANDLE_MOUSE_ENTER_PANEL": {
            return __assign(__assign({}, state), { panelId: action.payload });
        }
        case "HANDLE_MOUSE_LEAVE_PANEL": {
            return __assign(__assign({}, state), { panelId: null });
        }
        case "HANDLE_MOUSE_ENTER_TAG": {
            return __assign(__assign({}, state), { panelTag: action.payload });
        }
        case "HANDLE_MOUSE_LEAVE_TAG": {
            return __assign(__assign({}, state), { panelTag: null });
        }
        default:
            return state;
    }
};
var Kanban = function (_a) {
    var panels = _a.panels, cards = _a.cards;
    var _b = useReducer(dispatchFn, __assign(__assign({}, kanbanData), { panels: panels, cards: cards })), state = _b[0], dispatch = _b[1];
    return (React.createElement(KanbanDispatch.Provider, { value: dispatch },
        React.createElement(KanbanContext.Provider, { value: [state, dispatch] }, React.createElement(KanbanBoard, { panels: state.panels, cards: state.cards }))));
};
export default Kanban;
